import { initPopupMediaSlider, openPopup } from './popups'; 
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { postRequest, getVideoFormat, videoPlayer } from './utilities';

export const urlParams = () => {
    // Initial setup of link listeners
    setupLinkListeners();

    // Check for URL params on load
    setTimeout(() => {
        handleURLParamsFunctionality(window.location.href);
    }, 750);
}

const setupLinkListeners = () => {
    let allATags = document.querySelectorAll('a:not(.cmplz-link)');
    allATags.forEach((aTag) => {
        let linkHref = aTag.getAttribute('href');
        if (linkHref && linkHref.indexOf("#") !== -1) {
            // Check if the event listener is already attached
            if (!aTag.classList.contains('listener-attached')) {
                aTag.addEventListener('click', handleLinkClick);
                aTag.classList.add('listener-attached');
            }
        }
    });
}

const handleLinkClick = (event) => {
    event.preventDefault();
    let targetEl = event.target.closest('a').getAttribute('href');
    handleURLParamsFunctionality(targetEl);
    return false;
}


async function handleURLParamsFunctionality(href){
	//#scrollTo:ElementIDToScrollTo  |   Will either load the page and scroll to that element ID, or scroll on click
	//#book:OTKey		     		 |   Will trigger the resevations popup. Add a locations OT Key to preselect that location
	//#inqure:TSFormID		     	 |   Will trigger the inquiry popup. Add a PE Space TS Form ID to load the specific form for that space (generic form used by default)
	//#popup:PopupID				 |   Will open a specific popup.
	//#video-player:URL				 |   Will open the video player with with the video from the URL.
	
	if ( href.indexOf("#") != -1 ) { // Check if the link has a #
		const hashRaw = href.split('#')[1];
		const hashValue = hashRaw.split(':');

		if( hashValue[0] === 'book' ) {	// Shortcut to open booking widget
			if ( hashValue[1] ) { // Locations OT Key has been passed through
				const locationKey = hashValue[1];
				const locationDropdown = document.getElementById('js__booking-location');

				// Set the location dropdown value to the location key
				locationDropdown.value = locationKey;
			}

			// Open the reservations popup
			openPopup('#reservations');
		} else if(hashValue[0] === 'inquire') { // Shortcut to open inquiry popup
			const tripleSeatContainers = document.querySelectorAll('.js-ts-form');

			if ( tripleSeatContainers ) {
				// Hide any open containers
				tripleSeatContainers.forEach(container => {
					container.classList.add('hidden');
				});

				const peSpaceId = hashValue[1];

				console.log(peSpaceId);
				
				tripleSeatContainers.forEach(container => {
					const containerTsFormId = container.getAttribute('data-ts-form-id');
					
					if ( peSpaceId === containerTsFormId ) {
						container.classList.remove('hidden');
					}
				});
			}

			// Open the inquiry popup
			openPopup('#inquiry');
		} else if ( hashValue[0] === 'video-player') {
			if ( hashValue[1] ) { // Video URL has been passed through
				const popup = document.querySelector('#video-player');
				// Show the loader
				popup.querySelector('.js-video-player-loader').classList.remove('hidden');

				const videoUrl = decodeURIComponent(hashValue[1].replace(/\+/g, ' '));
				const videoFileType = getVideoFormat(videoUrl);

				// Check if the video URL is valid
				if ( videoFileType ) {
					const videoContainer = popup.querySelector('.js-video-popup-container');
					const videoElement = videoContainer.querySelector('.js-video-popup-elem');
					const videoHtml = `<video class="js-popup-video"><source src="${videoUrl}" type="video/${videoFileType.replace('.', '')}">Your browser does not support the video tag.</video>`;

					// Update the video container with the new video
					videoElement.innerHTML = videoHtml;

					const video = videoElement.querySelector('.js-popup-video');
					
					// Add video classes
					video.classList.add('w-full', 'h-auto', 'lg:h-full', 'lg:object-cover');

					// Update the video duration element
					const videoDuration = popup.querySelector('.js-video-popup-duration');
					video.onloadedmetadata = () => {
						const hours = Math.floor(video.duration / 3600);
						const minutes = Math.floor(video.duration / 60);
						const seconds = Math.floor(video.duration - minutes * 60);

						if ( hours > 0 ) {
							videoDuration.innerHTML = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
						} else {
							videoDuration.innerHTML = `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
						}
					};

					// Call the videoPlayer function
					videoPlayer(video);

					// Hide the loader once the video is loaded
					popup.querySelector('.js-video-player-loader').classList.add('hidden');

					// Open the video player popup
					openPopup('#video-player');
				}
			}
		} else if ( hashValue[0] === 'team' ) {
			if ( hashValue[1] ) {
				const popup = document.querySelector('#team-popup');
				const popupContainer = popup.querySelector('.js-team-popup-container');

				// Hide the popup container
				popupContainer.classList.add('hidden');

				// Show the loader
				popup.querySelector('.js-team-popup-loader').classList.remove('hidden');

				// Open the team popup
				openPopup('#team-popup');

				// Fetch the team member data
				const formData = new FormData();
				formData.append('teamMemberId', hashValue[1]);
				formData.append('action', 'getTeamMemberPopupData');
			
				const data = await postRequest(formData);
			
				if ( data ) {
					// Update the team member popup with the new data
					popup.querySelector('.js-team-popup-media').innerHTML = data.media;
					popup.querySelector('.js-team-popup-title').innerHTML = `<h1 class="popup__title | f__title text-navy">${data.name}</h1>`;
					popup.querySelector('.js-team-popup-job').innerHTML = data.jobTitle;
					popup.querySelector('.js-team-popup-content').innerHTML = data.content;
					popup.querySelector('.js-team-popup-buttons').innerHTML = data.buttons;

					if ( data.mediaCount > 0 ) {
						// Initialize the team member media slider
						initPopupMediaSlider(popup.querySelector('.popup__team-media__swiper'));
					}

					// Hide the loader once the team member data is loaded
					popup.querySelector('.js-team-popup-loader').classList.add('hidden');

					// Show the popup container
					popupContainer.classList.remove('hidden');

					// Recall the setupLinkListeners function to handle any additional URL param buttons
					setupLinkListeners();
				} else {
					console.error('Error fetching team member data.');
				}
			}
		} else if ( hashValue[0] === 'fresh-catch' ) {
			if ( hashValue[1] ) {
				const popup = document.querySelector('#fresh-catch');
				const popupContainer = popup.querySelector('.js-fc-popup-container');

				// Hide the popup container
				popupContainer.classList.add('hidden');

				// Show the loader
				popup.querySelector('.js-fc-popup-loader').classList.remove('hidden');

				// Open the fresh catch popup
				openPopup('#fresh-catch');

				// Fetch the fresh catch data
				const formData = new FormData();
				formData.append('freshCatchId', hashValue[1]);
				formData.append('action', 'getFreshCatchPopupData');
			
				const data = await postRequest(formData);
			
				if ( data ) {
					// Update the fresh catch popup with the new data
					popup.querySelector('.js-fc-popup-media').innerHTML = data.media;
					popup.querySelector('.js-fc-popup-title').innerHTML = `<h1 class="popup__title | f__title text-navy">${data.name}</h1>`;
					popup.querySelector('.js-fc-popup-content').innerHTML = data.content;
					popup.querySelector('.js-fc-popup-buttons').innerHTML = data.buttons;

					// Update the popup location if passed through
					if ( hashValue[2] ) {
						popup.querySelector('.js-fc-popup-location').innerHTML = decodeURIComponent(hashValue[2].replace(/\+/g, ' '));
						popup.querySelector('.popup__location').classList.remove('hidden');
					} else {
						// Hide the location element if no location is passed through
						popup.querySelector('.popup__location').classList.add('hidden');
					}

					if ( data.mediaCount > 0 ) {
						// Initialize the popup media slider
						initPopupMediaSlider(popup.querySelector('.popup__fc-media__swiper'));
					}

					// Hide the loader once the fresh catch data is loaded
					popup.querySelector('.js-fc-popup-loader').classList.add('hidden');

					// Show the popup container
					popupContainer.classList.remove('hidden');

					// Recall the setupLinkListeners function to handle any additional URL param buttons
					setupLinkListeners();
				} else {
					console.error('Error fetching fresh catch data.');
				}
			}			
		} else if ( hashValue[0] === 'scrollTo' ){ // Scroll to the element!
			let elementToScrollTo = document.querySelector('#' + hashValue[1]);

			if ( elementToScrollTo ) {
				locationPageSubnavs = document.querySelectorAll(".m__lsubnav");

				if ( locationPageSubnavs ) {
					document.querySelector("#js__body").classList.remove('js__popup-active');

					locationPageSubnavs.forEach((subnav) => {
						subnav.classList.remove('open');
					});
				}

				gsap.registerPlugin(ScrollToPlugin);
				gsap.to(window, {duration: 1, scrollTo: elementToScrollTo});
			}
		} else if ( hashValue[0] == 'popup' ) { // Open a custom popup
			if ( hashValue[1] != null && hashValue[1] > '' ) {
				openPopup('#'+hashValue[1]);
			}
		} else {
			return false;
		}
	}
}